import Navigator from './components/Navigation';
import Content from './components/workContent';
import ChipFilter from './components/ChipFilter';
import thumbnail1 from './image/workThumbnails/thumbnail1.webp';
import thumbnail2 from './image/workThumbnails/thumbnail2.webp';
import thumbnail3 from './image/workThumbnails/thumbnail3.webp';
import thumbnail4 from './image/workThumbnails/thumbnail4.webp';
import thumbnail5 from './image/workThumbnails/thumbnail5.webp';
import thumbnail6 from './image/workThumbnails/thumbnail6.webp';
import thumbnail7 from './image/workThumbnails/thumbnail7.webp';
import thumbnail8 from './image/workThumbnails/thumbnail8.webp';
import thumbnail9 from './image/workThumbnails/thumbnail9.webp';
import thumbnail10 from './image/workThumbnails/thumbnail10.webp';
import thumbnail11 from './image/workThumbnails/thumbnail11.webp';
import thumbnail13 from './image/workThumbnails/thumbnail13.webp';
import thumbnail15 from './image/workThumbnails/thumbnail15.webp';
import thumbnail16 from './image/workThumbnails/thumbnail16.jpg';
import "animate.css/animate.min.css";
import { Dispatch, SetStateAction, useState, useEffect } from 'react';
import { Footer } from './components/Footer';
import { useMetaTags } from './utils/useMetaTags';
import { useLocation, useSearchParams } from 'react-router-dom';

interface WorkItem {
  id: string;
  projectPage: string;
  thumbnail: string;
  projectTitle: string;
  projectDescription: string;
  projectSubtitle: string;
  period: string;
  badge?: string;
  type: 'App' | 'Web';
  year: number;
  // 수동 번역(한국어) 전달용 선택적 프로퍼티들
  projectTitleKo?: string;
  projectDescriptionKo?: string;
  projectSubtitleKo?: string;
  badgeKo?: string;
}

function Works(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
    useMetaTags({
      title: 'Works - Lynkim',
      description: 'Product Design Portfolio - Works by Lynkim',
      image: '/ogimage.png',
    });

    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    
    // 필터 이름과 번호 매핑
    const filterMap: { [key: string]: number } = {
      'Recent': 0,
      'All': 1,
      'App': 2,
      'Web': 3,
      '2024~25': 4,
      '2022~23': 5,
      '2021~19': 6
    };

    const filterNameMap: { [key: number]: string } = {
      0: 'Recent',
      1: 'All',
      2: 'App',
      3: 'Web',
      4: '2024~25',
      5: '2022~23',
      6: '2021~19'
    };
    
    // URL 경로 또는 쿼리 파라미터에 따라 필터 결정
    const getFilterFromURL = () => {
      // 쿼리 파라미터 우선 확인
      const filterParam = searchParams.get('filter');
      if (filterParam && filterMap[filterParam] !== undefined) {
        return filterMap[filterParam];
      }
      
      // 경로 기반 필터링 (기존 방식 유지)
      const path = location.pathname;
      if (path === '/App') return 2;
      if (path === '/Web') return 3;
      if (path === '/2024') return 4;
      if (path === '/2023') return 5;
      if (path === '/2021') return 6;
      return 0; // /work 또는 기본값 - Recent 필터
    };

    const [activeFilter, setActiveFilter] = useState(getFilterFromURL());

    useEffect(() => {
      const newFilter = getFilterFromURL();
      setActiveFilter(newFilter);
    }, [location.pathname, searchParams]);

    // 필터 변경 핸들러
    const handleFilterChange = (value: SetStateAction<number>) => {
      const filterNumber = typeof value === 'function' ? value(activeFilter) : value;
      setActiveFilter(filterNumber);
      const filterName = filterNameMap[filterNumber];
      if (filterName) {
        // 현재 경로에 쿼리 파라미터 추가
        setSearchParams({ filter: filterName });
      }
    };

    // 모든 Work 데이터
    const allWorks: WorkItem[] = [
      {
        id: 'work15',
        projectPage: 'Work15',
        thumbnail: thumbnail15,
        projectTitle: 'New QR Order Solution',
        projectDescription: 'QR Designing a Web Service for Restaurant Food Ordering and Payment via QR Code',
        projectSubtitle: 'Karrot',
        period: '2025.07. - 2025.09.',
        badge: 'New',
        type: 'App',
        year: 2025,
        projectTitleKo: '새로운 QR오더 솔루션',
        projectDescriptionKo: '오프라인 매장에서 음식 주문 및 결제를 할 수 있는 QR오더 웹 서비스 디자인',
        projectSubtitleKo: '당근',
        badgeKo: 'New'
      },
      {
        id: 'work16',
        projectPage: 'Work16',
        thumbnail: thumbnail16,
        projectTitle: 'Expanding the Coverage of QR Order',
        projectDescription: 'Expanding the coverage of QR Order to various F&B market environments.',
        projectSubtitle: 'Karrot',
        period: '2025.10. - 2025.12.',
        badge: 'New',
        type: 'App',
        year: 2025,
        projectTitleKo: 'QR오더의 시장 커버리지 확대',
        projectDescriptionKo: '다양한 F&B 시장 환경에 맞춰 QR오더의 시장 커버리지 확대',
        projectSubtitleKo: '당근',
        badgeKo: 'New'
      },
      {
        id: 'work13',
        projectPage: 'Work13',
        thumbnail: thumbnail13,
        projectTitle: 'Obtaining Consent for Personalized Advertising',
        projectDescription: 'Obtain personalized advertising consent from new users to serve tailored ads.',
        projectSubtitle: 'Karrot',
        period: '2024.10. - 2024.12.',
        badge: 'New',
        type: 'App',
        year: 2024,
        projectTitleKo: '개인 맞춤형 광고 제공을 위한 동의 얻기',
        projectDescriptionKo: '개인화된 광고 제공을 위해 신규 가입자에게 최적의 동의율을 얻을 수 있는 UX 연구 및 설계',
        projectSubtitleKo: '당근',
        badgeKo: 'New'
      },
      {
        id: 'work8',
        projectPage: 'Work8',
        thumbnail: thumbnail8,
        projectTitle: 'A Bidding System in Search Ads',
        projectDescription: 'Designing a search advertising bidding system that anyone can easily use on mobile',
        projectSubtitle: 'Karrot',
        period: '2024.04 - 2024.06.',
        badge: 'New',
        type: 'App',
        year: 2024,
        projectTitleKo: '검색광고 키워드 입찰 시스템',
        projectDescriptionKo: '누구나 모바일에서 쉽게 사용할 수 있는 검색광고 키워드 입찰 시스템 설계',
        projectSubtitleKo: '당근',
        badgeKo: 'New'
      },
      {
        id: 'work7',
        projectPage: 'Work7',
        thumbnail: thumbnail7,
        projectTitle: 'New Catalog Manager for Ads',
        projectDescription: 'Design a catalog management platform that can manage and advertise millions of products for Karrot.',
        projectSubtitle: 'Karrot',
        period: '2024.01 - 2024.06.',
        badge: 'New',
        type: 'Web',
        year: 2024,
        projectTitleKo: '새로운 카탈로그 관리 플랫폼',
        projectDescriptionKo: '수백만 개의 상품을 관리하고 광고할 수 있는 카탈로그 관리 플랫폼 설계',
        projectSubtitleKo: '당근',
        badgeKo: 'New'
      },
      {
        id: 'work6',
        projectPage: 'Work6',
        thumbnail: thumbnail6,
        projectTitle: 'New Outlink-Type Ads',
        projectDescription: 'Introducing a new outlink-type advertisement for small businesses.',
        projectSubtitle: 'Karrot',
        period: '2023.04 - 2023.07.',
        type: 'App',
        year: 2023,
        projectTitleKo: '새로운 아웃링크형 광고',
        projectDescriptionKo: '소상공인을 위한 새로운 아웃링크형 광고 상품 도입',
        projectSubtitleKo: '당근'
      },
      {
        id: 'work10',
        projectPage: 'Work10',
        thumbnail: thumbnail10,
        projectTitle: 'Eliminating Concerns of Creating Ads',
        projectDescription: 'Encouraging ad creation to increase the activation rate.',
        projectSubtitle: 'Karrot',
        period: '2023.01 - 2023.03.',
        type: 'App',
        year: 2023,
        projectTitleKo: '광고 생성 부담 완화',
        projectDescriptionKo: '활성화율을 높이기 위해 광고 생성을 유도합니다.',
        projectSubtitleKo: '당근'
      },
      {
        id: 'work1',
        projectPage: 'Work1',
        thumbnail: thumbnail1,
        projectTitle: 'New Ads Platform for Experts',
        projectDescription: 'An entirely new advertising platform for mid- to large-scale advertisers.',
        projectSubtitle: 'Karrot',
        period: '2022.01. - 2022.08.',
        type: 'Web',
        year: 2022,
        projectTitleKo: '전문가용 새로운 광고 플랫폼',
        projectDescriptionKo: '중대형 광고주를 위한 완전히 새로운 광고 플랫폼입니다.',
        projectSubtitleKo: '당근'
      },
      {
        id: 'work4',
        projectPage: 'Work4',
        thumbnail: thumbnail4,
        projectTitle: 'Leading More Business Users to Advertising',
        projectDescription: 'An experiment of UX to induce users to start advertising.',
        projectSubtitle: 'Karrot',
        period: '2022.10 - 2022.12.',
        type: 'App',
        year: 2022,
        projectTitleKo: '더 많은 비즈니스 사용자를 광고로 유도',
        projectDescriptionKo: '사용자가 광고를 시작하도록 유도하는 UX 실험입니다.',
        projectSubtitleKo: '당근'
      },
      {
        id: 'work5',
        projectPage: 'Work5',
        thumbnail: thumbnail5,
        projectTitle: 'New Service Design',
        projectDescription: 'Designing an entirely new book-share platform for working people who want to develop compentency.',
        projectSubtitle: 'Bookcovery',
        period: '2020.01. - 2020.08.',
        type: 'App',
        year: 2020,
        projectTitleKo: '새로운 서비스 디자인',
        projectDescriptionKo: '역량 개발을 원하는 직장인을 위한 완전히 새로운 북 쉐어링 플랫폼을 설계했습니다.',
        projectSubtitleKo: '북커버리'
      },
      {
        id: 'work2',
        projectPage: 'Work2',
        thumbnail: thumbnail2,
        projectTitle: 'First User Process Design',
        projectDescription: 'Onboarding process design on bookcovery to make activation.',
        projectSubtitle: 'Bookcovery',
        period: '2020.05 - 2020.11.',
        type: 'App',
        year: 2020,
        projectTitleKo: '첫 사용자 프로세스 디자인',
        projectDescriptionKo: '활성화를 위한 북커버리의 온보딩 프로세스 디자인입니다.',
        projectSubtitleKo: '북커버리'
      },
      {
        id: 'work3',
        projectPage: 'Work3',
        thumbnail: thumbnail3,
        projectTitle: 'Store UX/UI Design',
        projectDescription: 'Mobile store tap UX/UI design on Styleshare to maximize store tap using rates and purchase amout.',
        projectSubtitle: 'Styleshare',
        period: '2020.10 - 2020.12.',
        type: 'App',
        year: 2020,
        projectTitleKo: '스토어 UX/UI 디자인',
        projectDescriptionKo: '스타일쉐어에서 스토어 탭 사용률과 구매 금액을 극대화하기 위한 모바일 스토어 탭 UX/UI 디자인입니다.',
        projectSubtitleKo: '스타일쉐어'
      },
      {
        id: 'work11',
        projectPage: 'Work11',
        thumbnail: thumbnail11,
        projectTitle: 'Improvement the mission contents UX',
        projectDescription: 'Improving content UX to increase mission completion rate.',
        projectSubtitle: 'Minding',
        period: '2019.01. - 2019.06.',
        type: 'App',
        year: 2019,
        projectTitleKo: '미션 콘텐츠 UX 개선',
        projectDescriptionKo: '미션 완료율을 높이기 위한 콘텐츠 UX 개선입니다.',
        projectSubtitleKo: '마인딩'
      }
    ];

    // 필터링 로직
    const getFilteredWorks = () => {
      switch (activeFilter) {
        case 0: // New
          return allWorks.filter(work => work.badge === 'New');
        case 1: // All
          return allWorks;
        case 2: // App
          return allWorks.filter(work => work.type === 'App');
        case 3: // Web
          return allWorks.filter(work => work.type === 'Web');
        case 4: // 2024~25
          return allWorks.filter(work => work.year >= 2024);
        case 5: // 2022~23
          return allWorks.filter(work => work.year >= 2022 && work.year <= 2023);
        case 6: // 2021~19
          return allWorks.filter(work => work.year <= 2021);
        default:
          return allWorks.filter(work => work.badge === 'New');
      }
    };

    const filteredWorks = getFilteredWorks();

    // 3개씩 그룹화
    const groupWorksIntoRows = (works: WorkItem[]) => {
      const rows: WorkItem[][] = [];
      for (let i = 0; i < works.length; i += 3) {
        rows.push(works.slice(i, i + 3));
      }
      return rows;
    };

    const workRows = groupWorksIntoRows(filteredWorks);

    return (
      <div>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav}/>
      <div className='pageTitle'>Works</div>  
        <ChipFilter activeFilter={activeFilter} setActiveFilter={handleFilterChange}/>
    <div className='workContentslist'>
          {workRows.map((row, rowIndex) => (
            <div key={rowIndex} className='contents zoomIn'>
              {row.map((work) => (
                <Content
                  key={work.id}
                  badge={work.badge}
                  projectPage={work.projectPage}
                  thumbnail={work.thumbnail}
                  projectTitle={work.projectTitle}
                  projectDescription={work.projectDescription}
                  projectSubtitle={work.projectSubtitle}
                  period={work.period}
                  projectTitleKo={work.projectTitleKo}
                  projectDescriptionKo={work.projectDescriptionKo}
                  projectSubtitleKo={work.projectSubtitleKo}
                  badgeKo={work.badgeKo}
                />
              ))}
              {/* 빈 공간 채우기 (마지막 행이 3개 미만일 때) */}
              {row.length < 3 && Array.from({ length: 3 - row.length }).map((_, index) => (
                <div key={`empty-${index}`} style={{flex: '1'}}/>
              ))}
            </div>
          ))}
      </div>
      <Footer/>
    </div>
    );
}

export default Works;
